<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14,4C12.9,4,12,4.9,12,6C12,6.47,12.17,6.9,12.44,7.24C12.44,7.24,11.76,8.15,11.76,8.15C11.53,8.05,11.27,8,11,8C10.07,8,9.29,8.64,9.07,9.5C9.07,9.5,7.93,9.5,7.93,9.5C7.71,8.64,6.93,8,6,8C5.53,8,5.1,8.17,4.76,8.44C4.76,8.44,3.85,7.76,3.85,7.76C3.95,7.53,4,7.27,4,7C4,6.63,3.89,6.29,3.72,5.99C3.72,5.99,5.99,3.72,5.99,3.72C6.29,3.89,6.63,4,7,4C8.1,4,9,3.1,9,2C9,0.9,8.1,0,7,0C5.9,0,5,0.9,5,2C5,2.37,5.11,2.71,5.28,3.01C5.28,3.01,3.01,5.28,3.01,5.28C2.71,5.11,2.37,5,2,5C0.9,5,0,5.9,0,7C0,8.1,0.9,9,2,9C2.47,9,2.9,8.83,3.24,8.56C3.24,8.56,4.15,9.24,4.15,9.24C4.05,9.47,4,9.73,4,10C4,10.37,4.11,10.71,4.28,11.01C4.28,11.01,3.01,12.28,3.01,12.28C2.71,12.11,2.37,12,2,12C0.9,12,0,12.9,0,14C0,15.1,0.9,16,2,16C3.1,16,4,15.1,4,14C4,13.63,3.89,13.29,3.72,12.99C3.72,12.99,4.99,11.72,4.99,11.72C5.29,11.89,5.63,12,6,12C6.93,12,7.71,11.36,7.93,10.5C7.93,10.5,9.07,10.5,9.07,10.5C9.29,11.36,10.07,12,11,12C12.1,12,13,11.1,13,10C13,9.53,12.83,9.1,12.56,8.76C12.56,8.76,13.24,7.85,13.24,7.85C13.47,7.95,13.73,8,14,8C15.1,8,16,7.1,16,6C16,4.9,15.1,4,14,4C14,4,14,4,14,4Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Layout',
} as DefineComponent
</script>
